import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { getApiBaseUrl } from '@/lib/api'
import { getAuthHeaders } from '@/services/api'

export type TimePeriod = 'all' | 'week' | 'month' | 'year'

export interface DashboardMetrics {
	isPro: boolean
	viewableLimits: {
		responses: number
		bugs: number
		features: number
		reviews: number
	}
	totalHiddenCountThisPeriod: number
	totalFeedback: number
	feedbackDistribution: { type: string; count: number }[]
	recentActivity: any[]
}

export function useDashboardData(
	programId: string | null,
	timePeriod: TimePeriod,
	teamId: string | null
) {
	return useQuery<DashboardMetrics, Error>({
		queryKey: ['dashboardData', programId, timePeriod, teamId],
		enabled: !!programId && !!teamId,
		queryFn: async () => {
			if (!programId)
				throw new Error('No program ID provided for dashboard data')
			if (!teamId) throw new Error('No team ID provided for dashboard data')

			const headers = await getAuthHeaders()
			const { data } = await axios.get<DashboardMetrics>(
				`${getApiBaseUrl()}/api/dashboard/summary`,
				{
					params: {
						programId,
						timePeriod,
						teamId,
					},
					headers,
				}
			)
			return data
		},
		staleTime: 5 * 60 * 1000,
		gcTime: 10 * 60 * 1000,
		refetchOnWindowFocus: false,
		retry: 2,
		retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 3000),
	})
}
